import * as React from 'react';
import { primaryTextColor } from '../../../styles/SharedStyles';
import { useThemeContext } from '../../../context';
import { LabeledToggle } from '../../Shared';
import { PwWebConection } from '../../../types';
import { AuthService } from '../../../services';
import { User } from 'oidc-client';

export interface ConnectionDefaultTabToggleProps {
  tabIsDefault: boolean;
  setTabIsDefault: (value: boolean) => any;
  isPw365Project: boolean;
  connection?: PwWebConection;
  label?: string;
  user?: User;
}

export function ConnectionDefaultTabToggle({
  tabIsDefault,
  setTabIsDefault,
  user,
  isPw365Project,
  connection,
  label = 'Set created tab as default for connection',
}: ConnectionDefaultTabToggleProps): JSX.Element {
  const theme = useThemeContext();

  const isAdmin = AuthService.userIsAdmin(user);
  const disabled = isPw365Project ? !isAdmin : !connection || !isAdmin;

  return (
    <LabeledToggle
      checked={tabIsDefault}
      onToggle={setTabIsDefault}
      labelText={label}
      labelStyles={{
        label: { display: 'block', position: 'relative', padding: '5px 0' },
        span: { color: primaryTextColor(theme), marginLeft: '-8px' },
        toggle: { transform: 'scale(0.66)', marginLeft: '-8px' },
      }}
      disabled={disabled}
    />
  );
}
